export default class MessageFormatterUtil {

    /**
     * Método para formatar mensagem de erro. 
     * O argumento deve ser um array onde a função construirá uma String formatada.
     * Basicamente o procedimento consiste em adicionar, no início da String, um artigo no singular,
     * e adicionar a String 'é obrigatório' ou 'são obrigatórios' no final.
     * @param {Array} errors 
     * @returns {String} errorMessage
     */
    static formatErrorMessage(errors) {
        if(!errors || !errors.length) return errors
        if(errors.length == 1) return `O(a) ${errors.toString()} é obrigatório`
        let errorMessage = 'O(a) '
        for(let i=0; i < errors.length; i++){
            if(i == errors.length-1) errorMessage += `e ${errors[i]} `
            else if(i == errors.length-2) errorMessage += `${errors[i]} `
            else errorMessage += `${errors[i]}, `
        }
        errorMessage += 'são obrigatórios.'
        return errorMessage
    }

}


// WEBPACK FOOTER //
// ./src/utils/MessageFormatterUtil.js